import { Deserializable } from "./Deserializable";

export class EstructuraDinamicaHeader implements Deserializable {

  domaine?: string;
  subDomainPP?: string;
  subDomainJO?: string;
  subdomainPurp?: string;
  endpoint?: string;
  route?: string;
  title?: string;
  add?: boolean;
  delete?: boolean;
  purposing?: boolean;
  country?: string;
  version?: number;
  separator?: string;
  matchKey?: string;
  section?: Array<any>;
  methodSort?: any;
  periodsMatchKeyField?: string;
  matrizVipField?: string;
  addPreview?: boolean;
  deletePreview?: boolean;
  bulkEditPreview?: boolean;
  addPreviewTwo?: boolean;
  deletePreviewTwo?: boolean;
  bulkEditPreviewTwo?: boolean;
  purposingProfileList?: Array<any>;
  profiles?: {
    ingestaConsumer?: string;
    ingestaCommercial?: string;
    editionConsumer?: string;
    editionCommercial?: string;
  };
  baseUrl?: string;
  baseUrlTwo?: string;
  function?: Array<{
    name?: string;
    description?: string;
    field?: string;
    value?: string;
    type?: string;
    showInPreview1?: boolean;
    showInPreview2?: boolean;
  }>;
  functionTwo?: Array<{
    name?: string;
    description?: string;
    field?: string;
    value?: string;
    type?: string;
    showInPreview1?: boolean;
    showInPreview2?: boolean;
  }>;

  constructor() {
    // This is intentional
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

class ChangeDetails {
  fieldToChange?: string;
  newValue?: string;
}

class ValuesDetails {
  value?: string;
  text?: string;
}
